<script>
import ClubEmployeeTrainerLicenseRepository from '../../js/repository/ClubEmployeeTrainerLicenseRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        employeeId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
            default: () => {},
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubEmployeeTrainerLicenseRepository.findTrainerLicenses,
                params: [this.employeeId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
